module.exports = function anonymous(it
) {
var out='<div class="row-fluid"> <div class="offset2 span8 empty-report-list centered"> <div class="icon-frown icon-4x inline"></div> <div class="inline message" rel="localize[reports.no-reports-found]">There are no reports available</div> </div></div>';return out;
}